import React from "react";
import { Button, Container } from "react-bootstrap";
import { useScroll } from "../../../../context/scroll-context";
const pricingIcon =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/best-price.svg";
const projects =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/code.svg";
const client =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/hireteam/customer-care.svg";

const HeroBanner = ({ backgroundImage, content, alt, developer }) => {
  const { scrollToSection, contactform, pricing } = useScroll();
  const handleScrollAndClose = (refName) => {
    scrollToSection(refName);
  };
  return (
    <section
      className="hire-team hero-section"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container fluid className="p-4 p-lg-5">
        <div className="content-block mb-3">
          <h2 className="text-white text-uppercase ft-wt-600 mb-4">
            Hire {developer} developers
          </h2>
          <p className="text-white mb-5">{content}</p>
          <div>
            <Button
              className="text-uppercase"
              variant="secondary"
              onClick={() => handleScrollAndClose(contactform)}
            >
              <h5 className="mb-0 text-primary">
                Apply for a free 2 weeks trial
              </h5>
            </Button>
          </div>
        </div>
        <div className="d-flex align-items-center gap-3 gap-lg-5 flex-wrap mt-4 mt-lg-5">
          <div>
            <div className="d-flex gap-2 align-items-center">
              <div>
                <img src={pricingIcon} alt="pricing" />
              </div>
              <Button
                variant="link"
                onClick={() => handleScrollAndClose(pricing)}
                className="p-0 text-decoration-underline text-white"
              >
                <h5 className="text-white mb-0">Plan and Pricing</h5>
              </Button>
            </div>
          </div>
          <div>
            <div className="d-flex gap-2 align-items-center">
              <div>
                <img src={projects} alt="projects" />
              </div>
              <h5 className="text-white mb-0">10+ {developer} Projects</h5>
            </div>
          </div>
          <div>
            <div className="d-flex gap-2 align-items-center">
              <div>
                <img src={client} alt="client" />
              </div>
              <h5 className="text-white mb-0">100% Client Satisfaction</h5>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default HeroBanner;
